import React, { useState } from "react";
import { Button } from "controls";
import { action, API, controller } from "api";
import { ToFormData } from "hooks";
import InputSupplier from "../Form/QuickAdding/InputSupplier";
import { useNavigate } from "react-router-dom";

const UpdateSupplier = ({ selectedRec, handleClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({ prodSuppliers: [] });

  const handleInpChg = (e) => {
    setValues((j) => ({
      ...j,
      prodSuppliers: [...e.target.value],
    }));
  };

  const handleSubmit = () => {
    setLoading(true);
    API(controller.Product + action.UpdateBCST).post(
      ToFormData({
        all: selectedRec?.all,
        ids: selectedRec?.items,
        type: "supplier",
        prodSuppliers: values.prodSuppliers.map((j) => ({ supplierId: j })),
      }),
      (res) => {
        setLoading(false);
        navigate(0);
        handleClose();
      }
    );
  };

  return (
    <div className="pt-4 flex flex-col gap-5">
      <InputSupplier {...{ handleInpChg, values, setValues }} size="large" />

      <div className="flex justify-end gap-2">
        <Button
          onClick={handleClose}
          variant="text"
          size="large"
          className="!min-w-[130px]"
        >
          Don't Update
        </Button>
        <Button size="large" loading={loading} onClick={handleSubmit}>
          Update Suppliers
        </Button>
      </div>
    </div>
  );
};

export default UpdateSupplier;
